<template>
    <div class="form__container" id="career_form">

        <div class="content">
            <p class="subline">career form</p>
            <p class="headline">join us</p>

            <template v-if="error_messages">
        
                <div class="messages__container" id="error_messages">

                    <h3>The following fields are invalid, please check:</h3>

                    <div class="message" v-for="error_message, key in error_messages" :key="key">

                        <p style="color: white;">{{ error_message[0] }}</p>

                    </div>

                </div>

            </template>

            <template v-if="form_submitted">
            
                <div class="submitted__message">

                    <Success/>

                    <p>Thank You for Your time!</p>

                </div>

            </template>

            <template v-else>


                <div class="form__section">

                    <p class="title">name:</p>

                    <div class="input__row space-between">
                        <input type="text" class="form-input" :class="(is_invalid('first_name')) ? 'invalid' : ''" v-model="first_name" placeholder="First name" />
                        <input type="text" class="form-input" :class="(is_invalid('last_name')) ? 'invalid' : ''" v-model="last_name" placeholder="Last name" />
                    </div>

                </div>

                <div class="form__section">

                    <p class="title">e-mail address:</p>

                    <div class="input__row start">
                        <input type="email" class="form-input full-width" :class="(is_invalid('email')) ? 'invalid' : ''" v-model="email_address" placeholder="Email" />
                    </div>

                </div>


                <div class="form__section">

                    <p class="title">applying for position:</p>

                    <div class="select__position" @click="this.dropdown_open = !this.dropdown_open">
                    
                        <div class="custom__dropdown" :class="(is_invalid('position')) ? 'invalid' : ''">
                            <template v-if="selected_position">
                                <div class="choice">{{ selected_position.name }}</div>
                            </template>
                            <template v-else>
                                <div class="choice half-opacity">Selected prefered position</div>
                            </template>

                            <div class="positions__dropdown" v-bind:class="(dropdown_open) ? 'visible' : ''">
                                <div v-for="position, index in positions" class="position" :key="index" @click="this.selected_position = position"><p>{{ position.name }}</p></div>
                            </div>
                        </div>

                        <div class="toggle" :class="(this.dropdown_open) ? 'up' : 'down'">
                            <img src="/images/careers/arrow_down.webp" width="21" height="18" alt="toggle dropdown" />
                        </div>

                    </div>

                </div>

                <div class="form__section">

                    <p class="title">PORTFOLIO</p>

                    <div class="input__row start">
                        
                        <input type="text" class="form-input portfolio" :class="(is_invalid('portfolio')) ? 'invalid' : ''" placeholder="Insert link of portfolio website" v-model="portfolio.url" />

                        <p class="separator">OR</p>

                        <template v-if="portfolio.name">
                            <div class="uploaded__filename">
                                <p class="top">SELECTED: </p>
                                <p class="bottom">{{ portfolio.name }}</p>
                            </div>
                            <div class="reset__selection" @click="resetSelection('portfolio')"><img src='/images/icons/x.png'/></div>
                        </template>
                        <template v-else>
                            <div class="fileupload__btn" @click="handleUpload('portfolio')">
                                <p>UPLOAD PDF</p>
                                <div class="span_bg"></div>
                            </div>
                        </template>
                        

                        <input type="file" accept="application/pdf" ref="portfolio" id="portfolio" @change="selectFile" hidden/>

                    </div>

                </div>

                <div class="form__section">

                    <p class="title">CV:</p>

                    <div class="input__row start" :class="(is_invalid('cv')) ? 'invalid' : ''">

                        <template v-if="cv.name">

                            <div class="uploaded__filename cv row-layout">
                                <p class="top">SELECTED: </p>
                                <p class="bottom">{{ cv.name }}</p>
                            </div>
                            <div class="reset__selection" @click="resetSelection('cv')"><img src='/images/icons/x.png'/></div>

                        </template>
                        <template v-else>

                            <p class="text">Upload your <strong>Curriculum Vitae</strong> as PDF file:</p>

                            <div class="fileupload__btn" @click="handleUpload('cv')">
                                <p>UPLOAD CV</p>
                                <div class="span_bg"></div>
                            </div>

                        </template>

                        <input type="file" accept="application/pdf" ref="cv" id="cv" @change="selectFile" hidden/>

                    </div>

                </div>

                <div class="form__section">

                    <p class="title">salary expectation:</p>

                    <div class="input__row start salary">
                        <input type="number" class="form-input salary" :class="(is_invalid('salary')) ? 'invalid' : ''" placeholder="Write down those numbers" v-model="salary" />
                        <p class="end-text">BAM</p>
                    </div>

                </div>

                <div class="form__section margin-bottom">
                    <p class="title">YOUR MESSAGE:</p>

                    <textarea aria-label="Your message" class="styled" :class="(is_invalid('message')) ? 'invalid' : ''" v-model="message"></textarea>

                </div>

                <ReCaptcha ref="captcha"></ReCaptcha>

                <template v-if="captcha_solved === false">
                    <div class="captcha-error"><p>Please complete the captcha challenge in order to continue.</p></div>
                </template>


                <div class="submit__form" @click="submitForm()">
                    <p>SEND MESSAGE</p>
                    <div class="span_bg"></div>
                </div>

            </template>
           
        </div>

    </div>
</template>
<script>

export default {
    data(){
        return {
            positions: [],
            selected_position: null,
            dropdown_open: false,
            portfolio: {
                file: null,
                name: null,
                url: null
            },
            cv: {
                file: null,
                name: null,
            },
            error_messages: null,
            submitting: false,

            first_name: '',
            last_name: '',
            email_address: '',
            salary: null,
            message: '',

            captcha_solved: null,
            form_submitted: false,
        }
    },
    created(){
        axios.get('/openpositions').then((response) => {
           this.positions = response.data;
        }).then(() => {
            this.positions.push({id: 0, name: "General Application"});
        })
    },
    mounted(){},
    methods: {

        selectFile(event){
            switch (event.target.id) {
                case 'portfolio':
                    if(!this.validateFileSize(event.target.files.item(0).size)){
                        return alert('Please select a file that is not larger than 10 MB in size.');
                    }

                    this.portfolio.file = event.target.files.item(0);
                    this.portfolio.name = event.target.files.item(0).name;
                    break;

                case 'cv':
                    if(!this.validateFileSize(event.target.files.item(0).size)){
                        return alert('Please select a file that is not larger than 10 MB in size.');
                    }

                    this.cv.file = event.target.files.item(0);
                    this.cv.name = event.target.files.item(0).name;
                    break;
            
                default:
                    return;
                    break;
            }
        },

        resetSelection(selected_object){
            switch (selected_object) {
                case 'portfolio':
                    this.portfolio.file = null;
                    this.portfolio.name = null;
                    document.getElementById(selected_object).value = null;
                    break;

                case 'cv':
                    this.cv.file = null;
                    this.cv.name = null;
                    document.getElementById(selected_object).value = null;
                    break;
            
                default:
                    return;
                    break;
            }
        },

        validateFileSize(fileSize){
            const fileMb = fileSize / 1024 ** 2;
            if(fileMb > 10) return false;
            return true;
        },

        handleUpload(element_id){
            document.getElementById(element_id).click();
        },

        is_invalid(field){
            if(this.error_messages){
                if(this.error_messages[field]){
                    return true;
                }
            }
            return false;
        },

        submitForm(){
            this.captcha_solved = this.$refs.captcha.isCompleted();
            if(!this.captcha_solved) return;

            const form_data = new FormData();

            // basic data
            form_data.append('first_name', this.first_name);
            form_data.append('last_name', this.last_name);
            form_data.append('email', this.email_address);
            form_data.append('position', (this.selected_position) ? this.selected_position.id : '');
            form_data.append('salary', this.salary);
            form_data.append('message', this.message);

            form_data.append('portfolio[file]', this.portfolio.file);
            form_data.append('portfolio[url]', this.portfolio.url);

            form_data.append('cv', this.cv.file);

           
            this.submitting = true;

            axios({
                method: "POST",
                url: '/careers/submit',
                data: form_data,
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then(response => {
                // console.log(response);
                this.submitting = false;
                this.form_submitted = true;
                document.getElementById('career_form').style = "padding-top: 20vh";
                document.getElementById('career_form').scrollIntoView();
                this.error_messages = null;
            })
            .catch(error => {
                // console.log('error', error);

                if(error.response.status === 419){
                    return alert('Please reload the page to continue.');
                }

                if(typeof error.response.data == 'object'){
                    this.error_messages = error.response.data;
                    document.getElementById('career_form').style = "padding-top: 20vh";
                    document.getElementById('career_form').scrollIntoView();
                    this.submitting = false;
                } else {
                    this.submitting = false;
                    console.log(error);
                    alert('SERVER ERROR');
                }

            })

        },
    }
}
</script>
<style lang="scss" scoped>

    .messages__container{
        display: flex;
        flex-direction: column;

        background: #212121;
        border: 1px solid #ff0000;
        border-radius: 8px;
        padding: 12px 24px;

        margin: 24px 0;
        margin-bottom: 0;

        h3{
            font-family: "DIN Next LT Pro Bold";
            font-style: normal;
            font-size: 25px;
            line-height: 25px;
            color: #FFFFFF;
            margin: 0;
            text-align: center;

            margin: 12px auto;
        }

        .message{
            
            p{
                font-family: "DIN Next LT Pro Light";
                font-style: normal;
                font-size: 16px;
                line-height: 16px;
                margin: 4px 0;
                color: white;
            }
        }
    }

    .form__container{
        width: 100%;
        max-width: 1464px;
        margin: 0 auto;

        .content{
            background: #343434;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            padding: 70px 65px;

            display: flex;
            flex-direction: column;

            .subline{
                font-family: 'DIN Next LT Pro Bold';
                font-style: normal;
                // font-weight: 700;
                font-size: 14px;
                line-height: 17px;

                color: #ED1163;
                margin: 0;
                text-transform: uppercase;
            }

            .headline{
                font-family: 'DIN Next LT Pro Bold';
                font-style: normal;
                // font-weight: 700;
                font-size: 30px;
                line-height: 36px;

                color: #FFFFFF;
                margin: 0;
                text-transform: uppercase;
            }

            .title{
                font-family: 'DIN Next LT Pro Bold';
                font-style: normal;
                // font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                display: flex;
                align-items: center;

                color: #FFFFFF;
                text-transform: uppercase;
            }

            .form__section{
                display: flex;
                flex-direction: column;
                margin-top: 51px;

                &.margin-bottom{
                    margin-bottom: 24px;
                }

                .title{
                    font-family: 'DIN Next LT Pro Bold';
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 20px;
                    line-height: 24px;

                    color: #FFFFFF;

                    margin: 0;
                    margin-bottom: 10px;
                }

                .input__row{
                    display: flex;
                    flex-direction: row;

                    &.invalid{
                        background: #ff00003b;
                    }

                    .text{
                        font-family: 'DIN Next LT Pro Regular';
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 16px;
                        line-height: 60px;

                        color: #FFFFFF;
                        margin: 0;
                    }

                    .end-text{
                        font-family: 'DIN Next LT Pro Regular';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 64px;
                        /* identical to box height */

                        color: #FFFFFF;
                        margin: 0;
                        margin-left: 15px;
                    }

                    &.space-between{
                        justify-content: space-between;
                    }

                    &.start{
                        justify-content: flex-start;
                    }
                }
            }
        }
    }

    .form-input{
        background: rgba(43, 43, 43, 0.75);
        // opacity: 0.75;
        border: 2px solid transparent;
        border-bottom: 2px solid #ED1163;
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);

        font-family: 'DIN Next LT Pro Regular';
        font-style: normal;
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;
        height: 60px;
        width: 100%;
        // max-width: 635px; - 2 x 35px
        max-width: 575px;
        outline: none;

        transition: all .3s ease;

        padding: 0 34px;

        &.invalid{
            background: #ff00003b;
        }

        &.full-width{
            max-width: calc(100% - 68px);
        }

        &.portfolio{
            // max-width: 980px;
            max-width: 966px;
        }

        &.salary{
            max-width: calc(100% - 55px);
        }

        &:focus{
            border-top-color: #ED1163;
            border-left-color: #ED1163;
            border-right-color: #ED1163;
        }

        &::placeholder{
            font-family: 'DIN Next LT Pro Light';
            opacity: 0.7;
        }
    }

    textarea.styled{
        background: rgba(43, 43, 43, 0.75);
        // opacity: 0.75;
        border: 2px solid transparent;
        border-bottom: 2px solid #ED1163;
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);

        font-family: 'DIN Next LT Pro Regular';
        font-style: normal;
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;
        min-height: 400px;
        width: 100%;
        // max-width: 635px; - 2 x 35px
        max-width: calc(100% - 68px);
        outline: none;

        transition: all .3s ease;

        padding: 34px;

        &.invalid{
            background: #ff00003b;
        }

        &:focus{
            border-top-color: #ED1163;
            border-left-color: #ED1163;
            border-right-color: #ED1163;
        }
    }

    .select__position{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        position: relative;
        cursor: pointer;
        user-select: none;

        .custom__dropdown{
            display: flex;
            flex-direction: row;
            z-index: 5;

            position: relative;

            height: 60px;

            background: rgba(43, 43, 43, 0.75);
            // opacity: 0.75;
            // border: 2px solid transparent;
            border: 2px solid #ED1163;
            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);

            font-family: 'DIN Next LT Pro Regular';
            font-style: normal;
            font-size: 16px;
            line-height: 19px;
            color: #FFFFFF;
            height: 60px;
            // width: 100%;
            width: calc(100% - 60px);
            // max-width: 635px; - 2 x 35px
            // max-width: 575px;
            outline: none;

            transition: all .3s ease;


            &.invalid{
                background: #ff00003b;
            }


            .choice{
                line-height: 60px;
                padding: 0 30px;

                &.half-opacity{
                    font-family: 'DIN Next LT Pro Light';
                    opacity: 0.7;
                    color: grey;
                }
            }

            .positions__dropdown{
                display: flex;
                flex-direction: column;
                width: 100%;
                position: absolute;
                left: 0;
                top: 60px;
                background: #212121;
                height: 0;
                overflow: hidden;

                transition: all .3s ease;

                &.visible{
                    height: auto;
                }

                .position{
                    display: block;
                    transition: all .3s ease;

                    &:hover{
                        background: #ED1163;
                    }

                    p{
                        line-height: 60px;
                        padding: 0 30px;
                        margin: 0;
                    }
                }
            }
            
        }

        .toggle{
            display: block;
            width: 60px;
            height: 60px;
            border: 2px solid #ED1163;
            box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25), inset 4px 4px 4px rgba(0, 0, 0, 0.25);

            transition: all .3s ease;

            img{
                display: block;
                margin: 21px auto;

                transition: all .3s ease;
            }

            &.down{
                img{
                    transform: rotate(0deg);
                }
            }

            &.up{

                img{
                    transform: rotate(180deg);
                }
            }
        }
    }

    .separator{
        font-family: 'DIN Next LT Pro Regular';
        font-style: normal;
        // font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        margin: auto 22px;

        color: #FFFFFF;
    }

    .fileupload__btn{
        display: block;
        background: rgba(15, 15, 15, 0.3);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        width: 230px;
        height: 60px;
        margin-top: 0;
        margin-bottom: auto;
        // margin-bottom: -9px;
        cursor: pointer;
        user-select: none;
        position: relative;
        overflow-y: hidden;
        z-index: 4;
        text-decoration: none;
        margin-left: auto;
        margin-right: 0;
        border: 1px solid #ED1163;

        p{
            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
            font-style: normal;
            // font-weight: 700;
            font-size: 20px;
            line-height: 60px;
            text-align: center;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            margin: 0 auto;

            color: #FFFFFF;
            position: relative;
            z-index: 4;
        }

        div.span_bg{
            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
            height: 100%;
            width: 100%;
            transition: all .3s ease-in-out;
            margin-top: auto;
            margin-bottom: 0;
            opacity: 0;

            position: absolute;
            bottom: -50px;
            z-index: 3;
        }

        &:hover{
            div.span_bg{
                height: calc(100%);
                bottom: 0;
                opacity: 1;
            }
        }
    
    }



    .submit__form{
        display: block;
        background: rgba(15, 15, 15, 0.3);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        width: 100%;
        max-width: 408px;
        height: 60px;
        margin: 24px auto;
        // margin-bottom: -9px;
        cursor: pointer;
        user-select: none;
        position: relative;
        overflow-y: hidden;
        z-index: 4;
        text-decoration: none;
        border: 1px solid #ED1163;

        p{
            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
            font-style: normal;
            // font-weight: 700;
            font-size: 20px;
            line-height: 60px;
            text-align: center;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            margin: 0 auto;

            color: #FFFFFF;
            position: relative;
            z-index: 4;
        }

        div.span_bg{
            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
            height: 100%;
            width: 100%;
            transition: all .3s ease-in-out;
            margin-top: auto;
            margin-bottom: 0;
            opacity: 0;

            position: absolute;
            bottom: -50px;
            z-index: 3;
        }

        &:hover{
            div.span_bg{
                height: calc(100%);
                bottom: 0;
                opacity: 1;
            }
        }
    }

    .uploaded__filename{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;

        &.cv{
            height: 60px;
        }

        &.row-layout{
            flex-direction: row;
        }

        .top{
            font-family: 'DIN Next LT Pro Regular';
            font-style: normal;
            // font-weight: 400;
            font-size: 16px;
            line-height: 19px;

            color: #FFFFFF;

            margin: 0;
            line-height: 20px;
        }

        .bottom{
            font-family: 'DIN Next LT Pro Regular';
            font-style: normal;
            // font-weight: 400;
            font-size: 16px;
            line-height: 19px;

            color: #FFFFFF;

            margin: 0;
            line-height: 20px;
        }

        &.cv{
            .top, .bottom{
                line-height: 60px;
            }
        }
        
    }

    .reset__selection{
        width: 24px;
        height: 24px;
        margin: auto;
        margin-left: 2px;

        cursor: pointer;

        &:hover{
            img{
                transform: scale(1.1);
            }
        }
        
        img{
            display: block;
            min-width: 100%;
            height: 100%;
            transition: all .3s ease;
        }
    }

    .captcha-error{
        display: block;
        margin: 12px auto;

        p{  
            font-family: 'DIN Next LT Pro Regular';
            color: #FFF;
            font-size: 20px;
            line-height: 20px;
            margin: 0;
            margin-top: 12px;
        }
    }

    .submitted__message{
        display: block;
        margin-top: 42px;

        p{
            color: #FFF;
            font-size: 20px;
            line-height: 20px;
            font-family: "DIN Next LT Pro Bold";
            margin: 0;
            text-align: center;
        }
    }

    @media screen and (max-width: 1470px) {
        .form__container{
            max-width: 90%;
        }
    }


    @media screen and (max-width: 836px) {

        .form__container{
            width: 90%;

            .content{
                padding: 30px 25px;

                .form__section{
                    .input__row{
                        &:not(.salary){
                            flex-direction: column;
                        }
                    }
                }
            }
        }

        .form-input{
            width: auto;
            margin-bottom: 14px;
        }

        .separator{
            margin: auto;
            text-align: center;
            margin-bottom: 12px;
        }

        .fileupload__btn{
            background: rgba(0, 0, 0, 0.6);
            border: 1px solid #ED1163;
            height: 31px;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 24px;
            margin-top: 24px;

            p{
                font-size: 12px;
                line-height: 33px;
            }
        }

        .reset__selection{
            margin: auto;
            margin-top: 24px;
        }

        .submit__form{
            background: rgba(0, 0, 0, 0.6);
            border: 1px solid #ED1163;
            height: 31px;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 42px;
            margin-top: 42px;

            p{
                font-size: 12px;
                line-height: 33px;
            }
        }

    }

</style>